import axios from 'axios'

import { ApiClient } from './client'
import { useBaseUrl } from '#imports'

const serviceBasePath = '/terminierungsportal/appointments/'

export const makeApiClient = (): ApiClient => {
  const axiosInstance = axios.create()
  const { baseUrl } = useBaseUrl()

  axiosInstance.defaults.baseURL = baseUrl + serviceBasePath
  return new ApiClient(axiosInstance)
}

export { useApi } from './plugin'
